import { ViewModel as model } from "./model";
import template from "./template.html";
import "./style.less";

import { registerComponent } from "@/utils/engine/register-component";
registerComponent("select-poll-folder-dialog", {
  model,
  template,
});
